/**
 * @fileoverview Types for AssignProjectModal component
 */

export interface Student {
  id: string
  firstName: string
  lastName: string
  avatar?: string
  groupIds: string[]
}

// Response shape from backend /api/group_school_terms/:id/:school_term_id/people
export interface GroupPeopleStudent {
  value: string        // student ID
  label: string        // full name
  avatar_middle?: string  // resized avatar URL
}

export interface ProjectGroup {
  id: string
  name: string
}

export interface AssignProjectData {
  projectId: string
  startDate: Date | null
  groupId: string | null
  assignedStudentIds: string[]
}

export interface AssignProjectModalProps {
  opened: boolean
  onClose: () => void
  onSave: (data: AssignProjectData) => void | Promise<void>
  projectId: string
  projectName?: string
  groups?: ProjectGroup[]
  students?: Student[]
  isLoading?: boolean
}

export interface StudentListItemProps {
  student: Student
  onAction: () => void
  actionType: 'add' | 'remove'
}

export interface AssignProjectState {
  startDate: Date | null
  selectedGroupId: string | null
  assignedStudentIds: string[]
  filterGroupId: string | null
  searchQuery: string
  isSubmitting: boolean
  isDirty: boolean
}

export interface AssignProjectContextValue extends AssignProjectState {
  setStartDate: (date: Date | null) => void
  setSelectedGroupId: (id: string | null, options?: { silent?: boolean }) => void
  setFilterGroupId: (id: string | null) => void
  setSearchQuery: (query: string) => void
  setIsSubmitting: (value: boolean) => void
  addStudent: (studentId: string) => void
  addAllStudents: (studentIds: string[]) => void
  removeStudent: (studentId: string) => void
  reset: () => void
  hasChanges: boolean
}
